<template>
    <div
        id="progress-animation"
        class="text-center my-8 d-flex flex-column pt-10"
        style="height: 350px;"
    >
        <!-- TODO: Set download progress loading -->
        <v-progress-circular
            v-if="false"
            class="justify-center"
            :rotate="360"
            :size="200"
            :width="20"
            :value="value"
            color="green darken-2 dark--text"
        >
            <template>
                <span class="export-progress h1 font-weight-bold">
                    {{ value }} %
                </span>
            </template>
        </v-progress-circular>

        <v-progress-circular
            :size="200"
            :width="20"
            class="justify-center"
            color="green darken-2 dark--text"
            indeterminate
        />

        <v-row
            class="justify-center"
            dense
            no-gutters
        >
            <span class="h3 green-text-textdarken-2 mx-auto mt-4 font-weight-bold">
                {{ !isImporting ? $t('habiteoStudio.downloadInProgress') : $t('habiteoStudio.importInProgress') }}
            </span>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: 'StepExportAnimation',
        props: {
            isDownloadComplete: {
                type: Boolean,
                required: false
            },
            isImporting: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                interval: {},
                value: 0,
            }
        },
        computed: {
            isDownloading() {
                return value < 100 ? true : false;
            }
        },
        beforeDestroy () {
            clearInterval(this.interval);
        },
        watch: {
            isDownloadComplete() {
                if (this.$props.isDownloadComplete)
                    this.$emit('download-success');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/components/StepExportAnimation.vue